import Swiper from "swiper";
import { Autoplay, A11y } from "swiper/modules";

export function kkLogoSlider() {
    const logoSlider = document.querySelectorAll(".block-logo-slider .logo-slider");
    if (logoSlider.length > 0) {
		logoSlider.forEach(slider => {
			const swiper = new Swiper(slider, {
                modules: [Autoplay, A11y],
                rewind: true,
                speed: 950,
                autoplay: { delay: 3000, disableOnInteraction: true },
                slidesPerView: 1.25,
                spaceBetween: 24,
                breakpoints: {
                    0: {
                        slidesPerView: 1.5,
                    },
                    480: {
                        slidesPerView: 2.125,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                    1280: {
                        slidesPerView: 4,
                    },
                    1600: {
                        slidesPerView: 4,
                        spaceBetween: 32,
                    },
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Zurück',
                    nextSlideMessage: 'Weiter',
                    firstSlideMessage: 'Dies ist das erste Logo',
                    lastSlideMessage: 'Dies ist das letzte Logo',
                    paginationBulletMessage: 'Gehe zu Logo {{index}}',
                },
            });
        });
    }
}
